export type ActionType =
  | 'SET_DESTINATION_POI_DATA'
  | 'REQUEST_DESTINATION_POI_DATA'
  | 'RECEIVED_DESTINATION_POI_DATA'
  | 'ERROR_DESTINATION_POI_DATA';

interface ActionProps {
  type: ActionType;
  isFetching?: boolean;
  data?: {} | any;
  error?: any;
  payload?: {} | any;
}

const initialDestinationPoiState = {
  isFetching: true,
  data: {},
  error: {},
};

const DestinationPoi = (
  state = initialDestinationPoiState,
  action: Partial<ActionProps>,
) => {
  switch (action.type) {
    case 'REQUEST_DESTINATION_POI_DATA': {
      return {
        ...state,
        isFetching: true,
      };
    }

    case 'RECEIVED_DESTINATION_POI_DATA': {
      const { payload = {} } = action;
      return {
        ...state,
        isFetching: false,
        data: { ...payload },
      };
    }

    case 'ERROR_DESTINATION_POI_DATA': {
      const { error = {} } = action;
      return {
        ...state,
        isFetching: false,
        error: { ...error },
      };
    }

    default:
      return state;
  }
};

export default DestinationPoi;
